export function validate (elementName, element) {
    if (element.value) {
        if (elementName === 'email address') {
            if (emailCheck(element.value)) {
                return true
            }
        } else {
            return true
        }
    }
}

export function emailCheck (email) {
    /* eslint-disable */
    const regex = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    /* eslint-enable */
    return regex.test(email)
}



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/forms.js